import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateDesktop = new ReduxAsyncAction<
  'UPDATE_DESKTOP',
  string | Option | undefined,
  { desktop: string | Option | undefined }
>('UPDATE_DESKTOP');

UpdateDesktop.registerRequest(async (desktop: string | Option | undefined) => {
  return { desktop };
});

export const UPDATE_DESKTOP = UpdateDesktop.actionNamespaceConstants;
export const updateDesktop = UpdateDesktop.request;

export type UpdateDesktopResponseAction = Action<typeof UPDATE_DESKTOP.response> & {
  data: { desktop: string | Option };
};
